/**
 * O motivo de um arquivo não recebido, em linguagem simples (E146.F1, GUS-179, ADR-0100 §2.6).
 *
 * Um só mapa para os dois lugares que o mostram: a tela de envio (a partir do `DocumentError`) e o
 * histórico do caso (a partir do motivo gravado no evento `arquivo_recusado`). O código que a tela
 * não conhece cai em `outro`, nunca aparece como código.
 */
import { ptBR } from '@/i18n/pt-BR';
import { DocumentError } from '@/lib/case_source_documents';

export type MotivoDaRecusa = keyof typeof ptBR.recusaDoArquivo.motivo;

const POR_CODIGO: Record<string, MotivoDaRecusa> = {
  unsupported_mime: 'tipo',
  file_too_large: 'tamanho',
  file_empty: 'vazio',
  unreadable: 'ilegivel',
  docx_corrupted: 'ilegivel',
};

export function motivoDaRecusa(codigo: string | null | undefined): MotivoDaRecusa {
  return (codigo && POR_CODIGO[codigo]) || 'outro';
}

export function motivoDoErro(err: unknown): MotivoDaRecusa {
  return err instanceof DocumentError ? motivoDaRecusa(err.reason) : 'outro';
}

export function textoDoMotivo(motivo: MotivoDaRecusa): string {
  return ptBR.recusaDoArquivo.motivo[motivo];
}
